<template>
  <div class="data-analytics-entry">
    <!-- 已发布作品列表：暂时不展示，保留 ?panel=works -->
    <template v-if="showWorksPanel">
      <header class="works-head">
        <div>
          <h2>账号作品</h2>
          <p>作品列表 / 导出 / 分组管理 · 看板数字仍以创作中心为准</p>
        </div>
        <el-button type="primary" plain @click="backToBoard">返回看板</el-button>
      </header>
      <PublishedWorksDashboard
        :accounts="publishAccounts"
        :api-base="apiBase"
        :avatar-src-fn="avatarSrc"
        :auto-open-groups="openGroupsOnWorks"
      />
    </template>

    <!-- 合并后的数据中心主屏：未选分组=全展示 -->
    <MatrixGroupBoard v-else embedded />

  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { publishV2Api } from '../api'
import PublishedWorksDashboard from '../components/PublishedWorksDashboard.vue'
import MatrixGroupBoard from './MatrixGroupBoard.vue'
import { resolveApiBaseURL } from '../utils/appBase'

export default {
  name: 'DataAnalytics',
  components: { PublishedWorksDashboard, MatrixGroupBoard },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const publishAccounts = ref([])
    const apiBase = resolveApiBaseURL()

    const showWorksPanel = computed(() => String(route.query.panel || '') === 'works')
    const openGroupsOnWorks = computed(() => String(route.query.focus || '') === 'groups')

    const avatarSrc = (row) => {
      const url = row?.avatar_url || row?.avatar || ''
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('data:')) return url
      return `${apiBase}${url}`
    }

    const backToBoard = () => {
      const q = { ...route.query }
      delete q.panel
      delete q.tab
      delete q.focus
      router.replace({ path: '/data-analytics', query: q })
    }

    onMounted(async () => {
      if (route.query.tab === 'phones') {
        router.replace('/settings/devices')
        return
      }
      if (!showWorksPanel.value) return
      try {
        const res = await publishV2Api.listAccounts()
        publishAccounts.value = res?.data?.items || res?.items || []
      } catch {
        publishAccounts.value = []
      }
    })

    return {
      showWorksPanel,
      openGroupsOnWorks,
      publishAccounts,
      apiBase,
      avatarSrc,
      backToBoard,
    }
  },
}
</script>

<style scoped>
.data-analytics-entry {
  min-height: 240px;
  width: 100%;
  max-width: none;
}
.works-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}
.works-head h2 {
  margin: 0 0 6px;
  font-size: 20px;
}
.works-head p {
  margin: 0;
  font-size: 12px;
  color: var(--mp-text-muted);
}
</style>
